<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgb(0,0,0,0)" color = "#00ff00"></ngx-spinner>
<gm-showcase showcase-title="View Reports">
  <div class="showcase-body">
    <label>Please select report:
      <select id="reportName" (change)="updateForm($event)">
        <option *ngFor="let option of dropdownDemo.options" [value]="option.value">{{option.name}}</option>
      </select>
    </label>
    <form [formGroup]="reportForm" novalidate>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group" [hidden]="!showSites">
          <label>Site: <select multiple [size]="10" formControlName="sitesCtrl">
            <option *ngFor="let si of sites" value={{si.siteId}}>
              {{si.siteName}}
            </option>
          </select>
          </label>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group" [hidden]="!showGovEndorsements">
          <label>Gov. Endorsements and Region:<br>
            <select formControlName="govEndorsementCtrl">
            <option *ngFor="let ge of govEndorsements" value={{ge.governmentEndorsementId}}>
              {{ge.endorsementName}}
            </option>
          </select>
          </label>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group" [hidden]="!showRegion">
          <label>Regions:<br>
            <select multiple [size]="5" formControlName="regionsCtrl">
              <option *ngFor="let re of regions" value={{re.regionId}}>
                {{re.regionName}}
              </option>
            </select>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group" [hidden]="!showDrivingLevels">
          <label>Driving Levels: <select formControlName="drivingLevels">
            <option *ngFor="let dl of driverLevels" value={{dl.drivingLevelId}}>
              {{dl.drivingLevelName}} | {{dl.description}}
            </option>
          </select>
          </label>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group" [hidden]="!showEndorsement">
          <label>Endorsements: <select formControlName="endorsements">
            <option *ngFor="let en of endorsements" value={{en.endorsementId}}>
              {{en.endorsementName}} | {{en.endorsementDesc}}
            </option>
          </select>
          </label>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group" [hidden]="!showCourses">
          <label>Training Courses: <select formControlName="courses">
            <option *ngFor="let tc of courses" value={{tc.trainingCourseId}}>
              {{tc.courseNumber}} | {{tc.courseName}}
            </option>
          </select>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group start-date" *ngIf="!hideDateFields && showStartDate">
          Start Date: <gm-datepicker name="startDate" id="startDate" formControlName="startDate"></gm-datepicker>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group start-date" *ngIf="!hideDateFields && showEndDateFull">
          End Date: <gm-datepicker name="showEndDateFull" id="showEndDateFull" formControlName="endDateFull"></gm-datepicker>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group" *ngIf="!hideDateFields && showEndDate">
          <label>Month: <select formControlName="endDateMonth">
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </select>
          </label>
          <label>Year: <input formControlName="endDateYear" maxlength="4" [size]="4" [width]="4"></label>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group" [hidden]="!showSelectAllDates">
          <label>
            <input type="checkbox" formControlName="selectAllDates" (change)="onSelectAllDatesChange($event)"> Select All Dates
          </label>
        </div>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group" [hidden]="!showSubmit">
        <button id="submit" (click)="showReport()">Submit</button>
      </div>
    </form>
  </div>
</gm-showcase>
